import axios from "axios";
import { getItem } from "@/lib/durableStorage";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => {
    // Dispatch a data-changed event on successful writes so pages can refetch.
    try {
      const m = (r.config?.method || "").toLowerCase();
      const u = r.config?.url || "";
      const isWrite = ["post", "put", "patch", "delete"].includes(m);
      const dataUrl = /\/(transactions|installments|budgets|goals|categories)/.test(u);
      if (isWrite && dataUrl) {
        window.dispatchEvent(new CustomEvent("malat:data-changed", { detail: { url: u, method: m } }));
      }
    } catch {}
    return r;
  },
  (err) => {
    // Do NOT auto-logout on 401 from arbitrary endpoints. A background API failure
    // must never kick the user out. Auth state is only cleared on explicit logout
    // (Settings → Logout) or on app boot when /auth/me confirms the token is dead.
    return Promise.reject(err);
  }
);

export default api;
